export default {"src":"/_next/static/media/Blood-Cancers.783b439a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};